var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "loading", staticStyle: { height: "100%", width: "100%" } },
    [
      _c(
        "v-container",
        {
          staticClass: "loading",
          staticStyle: { height: "100%" },
          attrs: { fluid: "" },
        },
        [
          _c(
            "v-row",
            { staticStyle: { height: "100%" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    {
                      staticStyle: { height: "100%" },
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _vm.text
                        ? _c("p", { staticClass: "initialLoadingText" }, [
                            _vm._v(_vm._s(_vm.text)),
                          ])
                        : _vm._e(),
                      _c("v-progress-circular", {
                        attrs: {
                          size: 30,
                          color: "primary",
                          indeterminate: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }